module.exports = __webpack_public_path__ + "static/media/image18.8b3b4ddd.JPG";